module.exports = __webpack_public_path__ + "7aa6b6349dc41001bbbc97041e1d7e30.pdf";